export default __webpack_public_path__ + "images/assets/67b6061611e2c97e9c4b093cb9e48db4.svg";